"use client";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@pex/ui-web";
import Image from "next/image";

const TESTIMONIALS = [
  {
    quote:
      "\u201CI\u2019ll never be able to say enough good things about Project Exodus that equate to the help and support I\u2019ve received through them. To say my life has been changed is an understatement. Through Project Exodus, and particularly through their ERS programme and Recovery Coaching sessions, my life has been completely turned around for the betterment of myself and the people around me.\u201D",
    name: "Mike Mckenna-Tuhi",
    avatar: "/images/testimonials/Countryside_Scenes_240_Hobbiton_7lr4sv.avif",
  },
  {
    quote:
      "\u201CAfter doing the ERS programme I now live in freedom and accept that I am human. Thanks to the programme I have realised that we do the damage to ourselves and we can change our mindsets and live in freedom.\u201D",
    name: "Sarah Davids",
    avatar:
      "/images/testimonials/Beaches___Oceans_50_Sailboat_in_Bahamas_l5d6y3.avif",
  },
  {
    quote:
      "\u201CLife Saving. Life Giving. Project Exodus changed my life, there are so many tools and skills to gain through Project Exodus. Really have learnt so much about myself and the addiction recovery cycle. I highly recommend the Exodus Recovery Skills programme.\u201D",
    name: "Mike Shaw",
    avatar: "/images/testimonials/Mountains_319_The_Pitons_jc2k2t.avif",
  },
  {
    quote:
      "\u201CNot only am I acquiring knowledge and applying it, but I have gained the confidence to share with others what I\u2019ve learnt. So overall my experience has been phenomenal. Life changing.\u201D",
    name: "Makhosini Cele",
    avatar:
      "/images/testimonials/Famous_Buildings_498_Heydar_Aliyev_Center_xlkwu2.webp",
  },
  {
    quote:
      "\u201CI love that there is not only valuable theory but also the most thought-provoking application exercises. Working through these exercises has changed my life, I feel so much better equipped to cope and deal with the issues that would previously have me in a spin.\u201D",
    name: "Camilla du Plessis",
    avatar:
      "/images/testimonials/Countryside_Scenes_230_Crop_field_mo4ptz.webp",
  },
  {
    quote:
      "\u201CHaving been in treatment myself years ago and having been a Coach at a Treatment Centre and being aware of the poor quality of their programme \u2014 I believe without a doubt that ERS, the content and the programme itself is of a very high standard and so relevant. As the programme is going along, you start seeing radical changes in some people.\u201D",
    name: "Tracy Marshall",
    avatar:
      "/images/testimonials/Historical_Sites_122_Leaning_Tower_of_Pisa_8v9fzl.avif",
  },
] as const;

const STAR_KEYS = ["1", "2", "3", "4", "5"] as const;

function StarRating() {
  return (
    <div aria-label="5 out of 5 stars" className="flex gap-0.5" role="img">
      {STAR_KEYS.map((n) => (
        <svg
          aria-hidden="true"
          className="h-5 w-5 fill-amber-400 text-amber-400"
          key={n}
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );
}

export function ErsTestimonialsCarousel() {
  return (
    <div className="relative">
      {/* Edge fade overlays — pointer-events-none so cards/buttons remain interactive */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-0 bottom-16 left-0 z-10 hidden w-32 sm:block"
        style={{
          background:
            "linear-gradient(to right, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%)",
        }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-0 right-0 bottom-16 z-10 hidden w-32 sm:block"
        style={{
          background:
            "linear-gradient(to left, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%)",
        }}
      />
      <Carousel className="w-full" opts={{ loop: true }}>
        <CarouselContent className="-ml-4">
          {TESTIMONIALS.map((t) => (
            <CarouselItem className="pl-4 md:basis-1/2" key={t.name}>
              <div className="flex h-full flex-col gap-4 rounded-2xl border bg-card p-6 shadow-sm">
                <StarRating />
                <p className="body-base flex-1">{t.quote}</p>
                <div className="flex items-center gap-3">
                  <div className="relative h-9 w-9 shrink-0 overflow-hidden rounded-full">
                    <Image
                      alt=""
                      className="object-cover"
                      fill
                      sizes="36px"
                      src={t.avatar}
                    />
                  </div>
                  <span className="font-semibold text-sm">{t.name}</span>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <div className="mt-6 flex items-center gap-2 px-1">
          <CarouselPrevious className="static translate-y-0" />
          <CarouselNext className="static translate-y-0" />
        </div>
      </Carousel>
    </div>
  );
}
